import React from "react";
import PropTypes from "prop-types";
export function Google({ color = "#333", width = 21, height = 21 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M22 12.242c0 1.882-.41 3.562-1.23 5.04a8.787 8.787 0 0 1-3.463 3.468c-1.489.833-3.203 1.25-5.143 1.25-1.83 0-3.525-.45-5.082-1.35A10.19 10.19 0 0 1 3.373 17 9.574 9.574 0 0 1 2 12c0-1.801.458-3.468 1.373-5a10.19 10.19 0 0 1 3.709-3.65A9.976 9.976 0 0 1 12.164 2c2.65 0 4.918.874 6.803 2.621l-2.746 2.62c-.874-.832-1.926-1.33-3.155-1.491-1.148-.161-2.282 0-3.402.484A6.295 6.295 0 0 0 6.959 8.41C6.221 9.46 5.852 10.656 5.852 12c0 1.156.287 2.211.861 3.165a6.654 6.654 0 0 0 2.295 2.299 5.986 5.986 0 0 0 3.156.867c1.23 0 2.309-.27 3.238-.807a5.636 5.636 0 0 0 1.844-1.734 5.328 5.328 0 0 0 .697-1.774h-5.78v-3.468h9.673c.11.592.164 1.156.164 1.694z"
      />
    </svg>
  );
}
Google.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
